import { useAuth } from "contexts/AuthProvider";
import { useCart } from "contexts/CartProvider";
import { HttpRequest } from "libs/http-helper";
import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { Navigate } from "react-router-dom";

function SyncCart() {
    const { getCart } = useCart();
    const { isAuthenticated, authenticating, getToken } = useAuth();
    const [redirect, setRedirect] = useState('');

    useEffect(() => {
        async function syncCart() {
            if (!authenticating && isAuthenticated()) {
                const data = await HttpRequest<string>("post", `${import.meta.env.VITE_ONLINE_SHOP_RUN_TIME_API_URL}/cart`, { Products: getCart()?.items }, true, getToken());
                console.log(`[sync cart] http response is: ${data}`);
                setRedirect('/order/apdorder');
            }
        };
        syncCart();
    }, [authenticating]);
    return !authenticating && redirect ? <Navigate to={redirect} /> : <><h1><FormattedMessage id="ml_114718" defaultMessage="X - Processing..."/></h1></>;
}

export default SyncCart;